/* global $ */
import { createElement, Component, PropTypes } from 'rlink-react';
import themeable from 'rlink-theme/themeable';

import studioScene from 'helpers/scenes/studioScene';
import Picture from 'rlink-repos/components/Picture';

const sliderSettings = {
  autoplay: false,
  autoplaySpeed: 4000,
  arrows: false,
  dots: true,
  respondTo: '#slider',
};

export default class StudioSection extends Component {
  componentDidMount () {
    $('#StudioSlider').slick(sliderSettings);
    $(window).on('slider-start', () => {
      $('#StudioSlider').slick('slickPlay');
    });
    $(window).on('slider-stop', () => {
      $('#StudioSlider').slick('slickPause');
    });
    studioScene();
  }

  render () {
    let {theme, studioSliderData, studioCopy} = this.props;
    return (
      <div>
        <article id="studio" className="layout-text bg-white text-black clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>The Studio</h2>
              <div dangerouslySetInnerHTML={{__html: studioCopy}} />
            </div>
          </div>
        </article>
        <article id="slider" className="layout-text bg-white clearfix">
          <p />
          <div className="wrapper">
            <div className="row">
              <div id="StudioSlider" className={`slider ${theme.StudioSlider}`}>
                {studioSliderData
                  .sort((a, b) => Number.parseInt(a.priority) - Number.parseInt(b.priority))
                  .map(item => (
                    item.mainImageFormats.src !== '' && (
                      <div key={`studioSlider-${item.mainImageFormats.src}`}>
                        <Picture
                          src={item.mainImageFormats.src}
                          widths={item.mainImageFormats.widths}
                          heights={item.mainImageFormats.heights}
                          formats={item.mainImageFormats.formats} />
                      </div>
                    )
                  ))}
              </div>
            </div>
          </div>
        </article>
      </div>
    );
  }
}

StudioSection.propTypes = {
  studioCopy: PropTypes.string,
  studioSliderData: PropTypes.arrayOf(PropTypes.shape({
    mainImageFormats: PropTypes.shape({
      src: PropTypes.string,
      widths: PropTypes.arrayOf(PropTypes.number),
      heights: PropTypes.arrayOf(PropTypes.number),
      formats: PropTypes.arrayOf(PropTypes.shape({
        contentType: PropTypes.string,
        fileExt: PropTypes.string,
      })),
    }),
    title: PropTypes.string,
    priority: PropTypes.number,
  })),
};

themeable(StudioSection, {
  classes: [
    'StudioSlider',
    'LandTitleAck',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/AboutUs/StudioSection.jsx